// ---------------------------------------------------------------------------
// Network status hook — single source of truth for "are we online?".
// ---------------------------------------------------------------------------
// Uses navigator.onLine + window online/offline events. Initial value reads
// navigator.onLine synchronously so the banner doesn't flash on hydrate.
// ---------------------------------------------------------------------------

import { useEffect, useState } from "react";

export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator === "undefined" ? true : navigator.onLine,
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return online;
}
